import { Permission } from 'src/app/modules/roles/constants/roles.constants';

export enum MenuItemType {
  Single = 'SINGLE',
  Section = 'SECTION',
}

export interface MenuItemSubsection {
  text: string;
  link: string[];
  permission?: Permission;
}
export interface MenuItem {
  text: string;
  icon: string;
  link: string[];
  permission: Permission;
  type: MenuItemType;
  subsections?: MenuItemSubsection[];
  expand?: boolean;
  isAvailableWhileOffline: boolean;
}
